// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IAssessmentCompetencyUnitApi,
  IAssessmentCompetencyUnitApiRequest,
  IAssessmentCompetencyUnitApiDownloadDocumentAttrs,
  IAssessmentCompetencyUnitApiDownloadDocumentResponse,
  IAssessmentCompetencyUnitApiGetDetailAttrs,
  IAssessmentCompetencyUnitApiDetailResponse,
} from 'interfaces/back-office/assessment/registration/competency-unit/competency-unit-api.interface'

// Constant
import { ApiConstantHc, ApiConstantHcBase } from 'constant'

// Utils
import { axios_renderHcUrl } from 'utils'

export class AssessmentCompetencyUnitApi
  extends BaseApi<IAssessmentCompetencyUnitApi>
  implements IAssessmentCompetencyUnitApiRequest
{
  readonly url = ApiConstantHc.ASSESSMENT_REGISTRATION_COMPETENCY_UNIT_URL
  private assessmentCompetencyUnitUrl = axios_renderHcUrl(this.url, ApiConstantHcBase.ASSESSMENT)

  /**
   * @description Get assessment unit competency detail
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAssessmentCompetencyUnitApiGetDetailAttrs} payload
   *
   * @return {Promise<IAssessmentCompetencyUnitApiDetailResponse>} Promise<IAssessmentCompetencyUnitApiDetailResponse>
   */
  async assessmentCompetencyUnit_getDetail(
    payload: IAssessmentCompetencyUnitApiGetDetailAttrs,
  ): Promise<IAssessmentCompetencyUnitApiDetailResponse> {
    return this.POST(`${this.assessmentCompetencyUnitUrl}/${payload.params.assessmentId}`, payload.body, {
      ...payload.requestConfig,
    })
  }

  /**
   * @description Download assessment unit competency document
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAssessmentCompetencyUnitApiDownloadDocumentAttrs} payload
   *
   * @return {Promise<IAssessmentCompetencyUnitApiDownloadDocumentResponse>} Promise<IAssessmentCompetencyUnitApiDownloadDocumentResponse>
   */
  async assessmentCompetencyUnit_downloadDocument(
    payload: IAssessmentCompetencyUnitApiDownloadDocumentAttrs,
  ): Promise<IAssessmentCompetencyUnitApiDownloadDocumentResponse> {
    return this.POST(
      `${this.assessmentCompetencyUnitUrl}/download/${payload.params.blobId}`,
      {},
      { ...payload.requestConfig, responseType: 'blob' },
    )
  }
}
